// @flow
import Component from './component'
export default () => ({
  path: 'allocate-interest',
  element: <Component />,
})
